<wm-form-activity-input-view
  [activity]="activity"
  [form]="form"
  [applicationId]="applicationId"
  #formActivityInputView
></wm-form-activity-input-view>

<div class="row ml-1" *ngIf="showSchedulerOptions">
  <div class="flex-column  pr-3" *ngIf="activity.canCancelInspection">
    <button
      class="btn btn-raised btn-primary float-left"
      (click)="tryCancelInspection()"
    >
      Cancel Inspection Appointment
    </button>
  </div>
  <div class="flex-column" *ngIf="activity.canBypassInspection">
    <button
      class="btn btn-raised btn-primary"
      (click)="tryBypassInspection()"
    >
      Bypass Inspection
    </button>
  </div>
</div>

<!-- Cancel Inspection modal -->
<wm-modal-confirm
  #cancelInspectionModal
  [showButton]="false"
  commandText="Yes"
  cancelText="No"
  title="Cancel Inspection Appointment"
  [form]="cancelForm"
  (accepted)="cancelInspection()"
  (canceled)="abortCancelInspection()"
>
  <ng-container *ngIf="cancellingInspection">
    Are you sure you want to canel this inspection appointment?
    
    <div [formGroup]="cancelForm">
      <div class="row mt-3">
        <div class="col">
          <span class="text-danger"> * </span>
            When Cancel Inspection Appointment is selected, the next activity will be {{ activity.model.requestActivityScreenName }}.  An email notification will be sent to the {{ requestActivityResponsibleRole }}, and it will include the reason for canceling, which must be provided here:
          <textarea
            style="height:100px"
            id="cancelReason"
            name="cancelReason"
            class="form-control mx-2"
            formControlName="cancelReason"
            aria-label="Cancel Reason"
            [(ngModel)]="cancelReason.value"
          ></textarea>
        </div>
      </div>
    </div>
  </ng-container>
</wm-modal-confirm>

<!-- Bypass Inspection modal -->
<wm-modal-confirm
  #bypassInspectionModal
  [showButton]="false"
  commandText="Yes"
  cancelText="No"
  title="Bypass Inspection"
  [form]="bypassForm"
  (accepted)="bypassInspection()"
  (canceled)="abortBypassInspection()"
>
  <ng-container *ngIf="bypassingInspection">
    Are you sure you want to bypass this inspection?
  
    <div [formGroup]="bypassForm">
      <div class="row mt-3">
        <div class="col">
          <span class="text-danger"> * </span>
          To proceed, please provide a reason for bypassing this inspection:
          <textarea
            style="height:100px"
            id="bypassReason"
            name="bypassReason"
            class="form-control mx-2"
            formControlName="bypassReason"
            aria-label="Bypass Reason"
            [(ngModel)]="bypassReason.value"
          ></textarea>
        </div>
      </div>
    </div>
  </ng-container>
</wm-modal-confirm>